import React, { useState } from 'react';
import { BookOpen, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader } from '../components/ui/card';
import { Separator } from '../components/ui/separator';
import BlogPostList from './Blog/BlogPostList';
import AuthorList from './Blog/AuthorList';

type BlogTab = 'posts' | 'authors';

const BlogManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<BlogTab>('posts');

  const tabs = [
    { id: 'posts' as BlogTab, label: 'Posts', icon: BookOpen },
    { id: 'authors' as BlogTab, label: 'Authors', icon: Users },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950">
      <div className="max-w-[1600px] mx-auto p-6 space-y-6">
        {/* Header */}
        <div className="backdrop-blur-sm bg-white/80 dark:bg-slate-900/80 rounded-2xl p-8 border border-slate-200 dark:border-slate-800 shadow-sm">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-900 via-slate-800 to-slate-700 dark:from-white dark:via-slate-100 dark:to-slate-300 bg-clip-text text-transparent">
            Blog Management
          </h1>
        </div>

        {/* Tabs */}
        <Card className="backdrop-blur-sm bg-white/90 dark:bg-slate-900/90 border-slate-200 dark:border-slate-800 shadow-lg">
          <CardHeader className="pb-4">
            <div className="flex flex-wrap gap-2">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.id;
                return (
                  <Button
                    key={tab.id}
                    variant={isActive ? 'default' : 'outline'}
                    size="sm"
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center gap-2 transition-all duration-200 ${
                      isActive
                        ? 'bg-gradient-to-r from-slate-900 to-slate-700 dark:from-slate-100 dark:to-slate-300 text-white dark:text-slate-900 shadow-md border-0'
                        : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800 hover:border-slate-300 dark:hover:border-slate-600'
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    {tab.label}
                  </Button>
                );
              })}
            </div>
            <Separator className="mt-4" />
          </CardHeader>
          <CardContent className="p-0">
            <div className="bg-gradient-to-br from-slate-50 to-white dark:from-slate-900 dark:to-slate-950">
              {activeTab === 'posts' && <BlogPostList />}
              {activeTab === 'authors' && <AuthorList />}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default BlogManagement;
